import * as React from 'react';
import { FormProvider, Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import StockForm from '../StockForm/StockForm';
import { STOCK_FORM_DEFAULT_VALUES } from '../StockForm/constants';
import { getStockFormSchema } from '../StockForm/StockForm.schema';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { TStockFormValues } from '../StockForm/StockForm.types';
import { TStockEdit } from './StockEdit.types';
import { useModals } from 'hooks/useModals';
import { useAppDispatch, useAppSelector } from 'store/store';
import {
  getStockListAsyncThunk,
  updateStockAsyncThunk,
} from 'store/stock/stock.action';
import { TStockTypeEnum } from 'api/stock/stock.types';

const StockEdit: TStockEdit = ({ item }) => {
  const localize = useLocalize();
  const dispatch = useAppDispatch();
  const modals = useModals();
  const { isLoading: isUpdateStockLoading } = useAppSelector(
    (store) => store.stock.updateStock
  );

  const stockFormSchema = React.useMemo(
    () => getStockFormSchema(localize),
    [localize]
  );

  const form = useForm<TStockFormValues>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: { ...STOCK_FORM_DEFAULT_VALUES, ...item },
    resolver: yupResolver(stockFormSchema) as Resolver<TStockFormValues>,
  });

  const handleSubmit = (data: TStockFormValues) => {
    dispatch(
      updateStockAsyncThunk({
        id: item.id,
        body: {
          ...data,
          id: item.id,
          variation: data.variation || undefined,
        },
        onSuccess: () => {
          modals.closeModal();
          dispatch(
            getStockListAsyncThunk({
              queryParams: {
                page: 1,
                perPage: 1000,
              },
            })
          );
        },
      })
    );
  };

  return (
    <FormProvider {...form}>
      <StockForm onSubmit={handleSubmit} isLoading={isUpdateStockLoading} />
    </FormProvider>
  );
};

export default StockEdit;
